import React from "react";
import { Typography } from "antd";
import styles from "./ListTable.module.css";

const { Text } = Typography;

export interface ListTableItem {
  id: string;
  title: string;
  source?: string;
  publisher?: string;
  date?: string;
  publishedDate?: string;
  comments?: number;
  image?: string;
  url?: string;
  text?: string;
}

export interface ListTableProps {
  title: string;
  items: ListTableItem[];
  renderItem?: (item: ListTableItem) => React.ReactNode;
  renderLogo?: () => React.ReactNode;
  onViewAll?: () => void;
  showViewAll?: boolean;
}

// Компонент для логотипа по умолчанию
const DefaultLogomark = () => {
  return (
    <div className={styles.logomark}>
      <div className={styles.logomarkContainer}>
        <div className={styles.logomarkIcon} />
      </div>
    </div>
  );
};

// Компонент для отображения элемента по умолчанию
const DefaultItemRenderer = (
  item: ListTableItem,
  renderLogo?: () => React.ReactNode
) => {
  const LogoComponent = renderLogo || DefaultLogomark;
  const date = item.date || item.publishedDate;
  const source = item.source || item.publisher;

  return (
    <div className={styles.tableItem}>
      <LogoComponent />
      <div className={styles.content}>
        <h4 className={styles.itemTitle}>{item.title}</h4>
        <div className={styles.metaInfo}>
          {source && <Text className={styles.source}>{source}</Text>}
          {source && date && <Text className={styles.separator}>·</Text>}
          {date && <Text className={styles.date}>{date}</Text>}
          {date && item.comments !== undefined && (
            <Text className={styles.separator}>·</Text>
          )}
          {item.comments !== undefined && (
            <Text className={styles.comments}>
              {item.comments} Comments
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

export const ListTable: React.FC<ListTableProps> = ({
  title,
  items,
  renderItem,
  renderLogo,
  onViewAll,
  showViewAll = true,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.divider} />
      </div>

      <div className={styles.table}>
        {items.map((item) => (
          <React.Fragment key={item.id}>
            {renderItem
              ? renderItem(item)
              : DefaultItemRenderer(item, renderLogo)}
          </React.Fragment>
        ))}
      </div>

      {showViewAll && (
        <div className={styles.footer}>
          <div className={styles.viewAllButton} onClick={onViewAll}>
            View all
          </div>
        </div>
      )}
    </div>
  );
};

